import BOMAPICall from "src/service/AdminAPICalls/BOMAPICall";
import BaseRepository from "../BaseRepository";


class BOMRepository extends BaseRepository {
   
  getBOMListAdmin = async (bomId) => {
    return await new BOMAPICall().getBomListByBomID({ bomId });
  };

}

export default BOMRepository;